import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tgMsgWindowContainer" }
const _hoisted_2 = { class: "tgMsgWindowHeader" }
const _hoisted_3 = { class: "tgMsgWindowHeader--name" }
const _hoisted_4 = { class: "tgMsgWindowHeader--button" }
const _hoisted_5 = { class: "tgMsgCard" }
const _hoisted_6 = { class: "tgMsgCard--header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "tgMsgCard--date" }, null, -1)
const _hoisted_8 = { class: "tgMsgCard--content" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 0,
  class: "tgReverseClass"
}
const _hoisted_22 = {
  key: 1,
  class: "tgReverseClass"
}
const _hoisted_23 = {
  class: "infinite-list",
  style: {"overflow":"auto"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }

import { useStore } from "vuex";
import { onMounted, computed, ref, watchEffect } from "vue";
import { More, Search, User, Document } from "@element-plus/icons-vue";
import { TgActions, TgGetters } from "@/store/modules/telegram";
import { TgMsg, TgMsgPayloadKV } from "@/store/modules/telegram/types";
import { tgStaticUrl } from "@/requests";
import { useRoute } from 'vue-router';
import ReverseElementScroll from "@/utils/scrollerHijack";
import GetFileSize from "@/utils/fileSize";
import changeToDateTime from '@/utils/timestamp2DateTime';


import { defineComponent } from "vue";
const __default__ = defineComponent({
    name: "TgContactMsgWindow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const store = useStore();
const route = useRoute();

const tgMsgContainer = ref<HTMLElement | null>(null);
const tgMsgListRef = ref<HTMLElement | null>(null);
onMounted(() => {
    const msgListElement = tgMsgListRef.value; // 获取元素的引用

    if (msgListElement) {
        ReverseElementScroll(msgListElement)
    }
})

const showParticipants = ref<boolean>(false)
const tgIdRef = computed(() => {
    return store.getters[`telegram/${TgGetters.getMeId}`];
});
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const selectedConv = computed(() => {
    return store.getters[`telegram/${TgGetters.getSelectedConv}`];
});
const selectedConvType = computed(() => {
    return store.getters[`telegram/${TgGetters.getSelectedConvType}`];
});
const isMsgLoading = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsMsgListLoading}`];
});
const participantsList = computed(() => {
    return selectedConv.value === null ? [] : store.getters[`telegram/${TgGetters.getChatroomGroupByName}`](selectedConv.value.Id);
});
const isParticipantsAllLoaded = computed(() => {
    return selectedConv.value === null ? false : store.getters[`telegram/${TgGetters.getIsPaticipantsAllLoadedByName}`](selectedConv.value.Id);
});
const isParticipantsLoading = computed(() => {
    return store.getters[`telegram/${TgGetters.getIsPaticipantsLoading}`];
});
const msgGroup = computed(() => {
    if (selectedConv.value) {
        return store.getters[`telegram/${TgGetters.getMsgGroupByConvId}`](selectedConv.value.Id);
    } else {
        return [];
    }
});
const headerName = computed(() => {
    return selectedConv.value ? selectedConv.value.Title : "";
});
const isCurrentMsgListAllLoaded = computed(() => {
    if (selectedConv.value) {
        return store.getters[`telegram/${TgGetters.getIsMsgListAllLoadedByConvId}`](selectedConv.value.Id);
    } else {
        return false;
    }
});
const shouldUpdate = computed(() => {
    return (!isCurrentMsgListAllLoaded.value && !isMsgLoading.value && selectedConv.value);
});
const handleScroll = () => {
    if (tgMsgListRef.value !== null && tgMsgContainer.value !== null) {
        return tgMsgListRef.value.scrollTop + tgMsgContainer.value.scrollHeight >= tgMsgListRef.value.scrollHeight
    } else {
        return false
    }
}

const loadMsgList = async () => {
    if (shouldUpdate.value && handleScroll()) {
        const projId = projectId.value
        const uid = targetId.value;
        const convid = selectedConv.value.Id;
        const tgId = tgIdRef.value
        try {
            await store.dispatch(`telegram/${TgActions.asyncGetMsgListByTgIdAndConvId}`, { projId, uid, tgId, convid });
        } catch (err) {
            console.log(err)
        }
    }
}
const handleClickForChat = () => {
    const projid = projectId.value;
    const uid = targetId.value;
    const convid = selectedConv.value.Id;
    const tgid = tgIdRef.value
    if (selectedConvType.value === "chat" || selectedConvType.value === "channel") {
        showParticipants.value = true;
        if (!isParticipantsAllLoaded.value && !isParticipantsLoading.value) {
            store.dispatch(`telegram/${TgActions.asyncGetParticipantsByUidAndTgIdAndConvId}`, { projid, uid, tgid, convid });
        }
    }
}
const loadParticipantsList = () => {
    if (!isParticipantsAllLoaded.value && !isParticipantsLoading.value) {
        const projid = projectId.value;
        const uid = targetId.value;
        const convid = selectedConv.value.Id;
        const tgid = tgIdRef.value
        if (selectedConvType.value === "chat" || selectedConvType.value === "channel") {
            store.dispatch(`telegram/${TgActions.asyncGetParticipantsByUidAndTgIdAndConvId}`, { projid, uid, tgid, convid });
        }
    }
}

const getMsgSender = (msg: TgMsg): string => {
    // if ('UserName' in msg) {
    //     return msg.UserName === "" ? msg.FromId.toString() : msg.UserName;
    // } else {
    //     return msg.FromId.toString();
    // }
    return msg.DisplayTitle
}

const getValueByKey = (data: TgMsgPayloadKV[], key: string): string => {
    if (data !== null) {
        const urlobj = data.find(obj => obj.Key === key)
        const url = urlobj ? urlobj.Value : "";
        return url

    } else {
        return ""
    }
}

const handleOpenLink = (link: string) => {
    window.open(link)
}

watchEffect(async () => {
    if (shouldUpdate.value && msgGroup.value.msgList.length === 0) {
        const projId = projectId.value
        const uid = targetId.value;
        const convid = selectedConv.value.Id;
        const tgId = tgIdRef.value
        try {
            await store.dispatch(`telegram/${TgActions.asyncGetMsgListByTgIdAndConvId}`, { projId, uid, tgId, convid });

            while (handleScroll() && shouldUpdate.value) {
                await loadMsgList()
            }

        } catch (err) {
            console.log(err)
        }
    }
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(headerName)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          icon: _unref(Search)
        }, null, 8, ["icon"]),
        _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          icon: _unref(More),
          onClick: handleClickForChat
        }, null, 8, ["icon"])
      ])
    ]),
    _createElementVNode("div", {
      class: "tgMsgWindowContent",
      ref_key: "tgMsgContainer",
      ref: tgMsgContainer
    }, [
      _createElementVNode("div", {
        onScroll: loadMsgList,
        class: "tgMsgList tgReverseClass",
        ref_key: "tgMsgListRef",
        ref: tgMsgListRef
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(msgGroup).msgList, (msg, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "tgMsgContent tgReverseClass",
            key: msg.FromId + '_' + index
          }, [
            (_openBlock(), _createElementBlock("div", {
              class: "tgMsg",
              key: msg.Sequence
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", null, _toDisplayString(getMsgSender(msg)), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(changeToDateTime)(msg.Date)), 1)
                ]),
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (msg.Media !== null && msg.Media.Status === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (msg.Media.Type === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_el_image, {
                                style: {"width":"200px","height":"200px"},
                                src: getValueByKey(msg.Media.Payload, 'url'),
                                title: "点击查看大图",
                                "preview-src-list": [getValueByKey(msg.Media.Payload, 'url')],
                                fit: "contain",
                                "preview-teleported": true
                              }, null, 8, ["src", "preview-src-list"]),
                              (msg.Message !== '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(msg.Message), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (msg.Media.Type === 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_el_card, {
                                shadow: "hover",
                                style: {"width":"400px","height":"90px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, {
                                    size: 30,
                                    style: {"float":"left","width":"10%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(User))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_text, { style: {"float":"right","width":"88%"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("UserId: " + _toDisplayString(getValueByKey(msg.Media.Payload, 'userId')), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("UserName: " + _toDisplayString(getValueByKey(msg.Media.Payload, 'firstName') + ' ' +
                                                    getValueByKey(msg.Media.Payload, 'lastName')), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("PhoneNumber: " + _toDisplayString(getValueByKey(msg.Media.Payload, 'phoneNumber')), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (msg.Message !== '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(msg.Message), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (msg.Media.Type === 6)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (getValueByKey(msg.Media.Payload, 'url') !== '')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "primary",
                                    onClick: ($event: any) => (handleOpenLink(getValueByKey(msg.Media.Payload, 'url')))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_card, {
                                        shadow: "hover",
                                        style: {"width":"400px","height":"80px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, {
                                            size: 28,
                                            style: {"float":"left","width":"10%"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(Document))
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_text, { style: {"float":"right","width":"88%"} }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_row, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(getValueByKey(msg.Media.Payload, 'fileName')), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_el_row, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(GetFileSize)(Number(getValueByKey(msg.Media.Payload, 'size')))), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (msg.Message !== '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(msg.Message), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (msg.Media.Type === 7)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createTextVNode(_toDisplayString(msg.Message) + " ", 1),
                              (getValueByKey(msg.Media.Payload, 'url') !== '')
                                ? (_openBlock(), _createBlock(_component_el_link, {
                                    key: 0,
                                    type: "primary",
                                    onClick: ($event: any) => (handleOpenLink(getValueByKey(msg.Media.Payload, 'url')))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getValueByKey(msg.Media.Payload, 'url')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (msg.Media !== null && msg.Media.Status === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (msg.Media.Type === 6)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createVNode(_component_el_card, {
                                  shadow: "hover",
                                  style: {"width":"400px","height":"80px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, {
                                      size: 28,
                                      style: {"float":"left","width":"10%"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Document))
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_text, { style: {"float":"right","width":"88%"} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_row, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(getValueByKey(msg.Media.Payload, 'fileName')) + "(未下载)", 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_el_row, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(GetFileSize)(Number(getValueByKey(msg.Media.Payload, 'size')))), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                (msg.Message !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(msg.Message), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(msg.Message), 1))
                ])
              ])
            ]))
          ]))
        }), 128)),
        (_unref(isMsgLoading))
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, "加载中......"))
          : _createCommentVNode("", true),
        (_unref(isCurrentMsgListAllLoaded))
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, "------已加载全部-------"))
          : _createCommentVNode("", true)
      ], 544)
    ], 512),
    _createVNode(_component_el_dialog, {
      class: "show-participants",
      modelValue: showParticipants.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showParticipants).value = $event)),
      title: "群组成员"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(participantsList).userList, (user) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 6,
                  key: user
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, {
                      class: "userCard",
                      "body-style": { padding: '10px', height: '100px' },
                      shadow: "never"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(User))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" name: " + _toDisplayString(user.Name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" userName:" + _toDisplayString(user.Username), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          (_unref(isParticipantsLoading))
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, "加载中......"))
            : _createCommentVNode("", true),
          (_unref(isParticipantsAllLoaded))
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, "------已加载全部-------"))
            : _createCommentVNode("", true)
        ])), [
          [_directive_infinite_scroll, loadParticipantsList]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})